/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AccountQuoteResponse as ModelsV3LoanManagementAccountQuoteResponse } from '../models/Models/v3/LoanManagement/account-quote-response';
import { AccountTypeCsResponseListBaseResponse as ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse } from '../models/Models/v3/LoanManagement/account-type-cs-response-list-base-response';
import { AddAccountRequest as ModelsV3LoanManagementAddAccountRequest } from '../models/Models/v3/LoanManagement/add-account-request';
import { AddAttachmentsResponseBaseResponse as ModelsV3LoanManagementAddAttachmentsResponseBaseResponse } from '../models/Models/v3/LoanManagement/add-attachments-response-base-response';
import { ExistingClientResponseListBaseResponse as ModelsV3LoanManagementExistingClientResponseListBaseResponse } from '../models/Models/v3/LoanManagement/existing-client-response-list-base-response';
import { ExistingClientResponseListPagedBaseResponse as ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse } from '../models/Models/v3/LoanManagement/existing-client-response-list-paged-base-response';
import { ExternalPartyResponse as ModelsV3LoanManagementExternalPartyResponse } from '../models/Models/v3/LoanManagement/external-party-response';
import { MbiRateChartResponse as ModelsV3LoanManagementMbiRateChartResponse } from '../models/Models/v3/LoanManagement/mbi-rate-chart-response';
import { SecurityItemResponse as ModelsV3LoanManagementSecurityItemResponse } from '../models/Models/v3/LoanManagement/security-item-response';
import { ValidateBankAccountResponseBaseResponse as ModelsV3LoanManagementValidateBankAccountResponseBaseResponse } from '../models/Models/v3/LoanManagement/validate-bank-account-response-base-response';
import { v3LoanManagementAccountsPost$Json$Json } from '../fn/loan-management/v-3-loan-management-accounts-post-json-json';
import { V3LoanManagementAccountsPost$Json$Json$Params } from '../fn/loan-management/v-3-loan-management-accounts-post-json-json';
import { v3LoanManagementAccountsPost$Json$Plain } from '../fn/loan-management/v-3-loan-management-accounts-post-json-plain';
import { V3LoanManagementAccountsPost$Json$Plain$Params } from '../fn/loan-management/v-3-loan-management-accounts-post-json-plain';
import { v3LoanManagementAccountsPost$Json$Xml } from '../fn/loan-management/v-3-loan-management-accounts-post-json-xml';
import { V3LoanManagementAccountsPost$Json$Xml$Params } from '../fn/loan-management/v-3-loan-management-accounts-post-json-xml';
import { v3LoanManagementAccountsPost$Xml$Json } from '../fn/loan-management/v-3-loan-management-accounts-post-xml-json';
import { V3LoanManagementAccountsPost$Xml$Json$Params } from '../fn/loan-management/v-3-loan-management-accounts-post-xml-json';
import { v3LoanManagementAccountsPost$Xml$Plain } from '../fn/loan-management/v-3-loan-management-accounts-post-xml-plain';
import { V3LoanManagementAccountsPost$Xml$Plain$Params } from '../fn/loan-management/v-3-loan-management-accounts-post-xml-plain';
import { v3LoanManagementAccountsPost$Xml$Xml } from '../fn/loan-management/v-3-loan-management-accounts-post-xml-xml';
import { V3LoanManagementAccountsPost$Xml$Xml$Params } from '../fn/loan-management/v-3-loan-management-accounts-post-xml-xml';
import { v3LoanManagementAccountTypesGet$Json } from '../fn/loan-management/v-3-loan-management-account-types-get-json';
import { V3LoanManagementAccountTypesGet$Json$Params } from '../fn/loan-management/v-3-loan-management-account-types-get-json';
import { v3LoanManagementAccountTypesGet$Plain } from '../fn/loan-management/v-3-loan-management-account-types-get-plain';
import { V3LoanManagementAccountTypesGet$Plain$Params } from '../fn/loan-management/v-3-loan-management-account-types-get-plain';
import { v3LoanManagementAccountTypesGet$Xml } from '../fn/loan-management/v-3-loan-management-account-types-get-xml';
import { V3LoanManagementAccountTypesGet$Xml$Params } from '../fn/loan-management/v-3-loan-management-account-types-get-xml';
import { v3LoanManagementAttachmentsPost$Json$Json } from '../fn/loan-management/v-3-loan-management-attachments-post-json-json';
import { V3LoanManagementAttachmentsPost$Json$Json$Params } from '../fn/loan-management/v-3-loan-management-attachments-post-json-json';
import { v3LoanManagementAttachmentsPost$Json$Plain } from '../fn/loan-management/v-3-loan-management-attachments-post-json-plain';
import { V3LoanManagementAttachmentsPost$Json$Plain$Params } from '../fn/loan-management/v-3-loan-management-attachments-post-json-plain';
import { v3LoanManagementAttachmentsPost$Json$Xml } from '../fn/loan-management/v-3-loan-management-attachments-post-json-xml';
import { V3LoanManagementAttachmentsPost$Json$Xml$Params } from '../fn/loan-management/v-3-loan-management-attachments-post-json-xml';
import { v3LoanManagementAttachmentsPost$Xml$Json } from '../fn/loan-management/v-3-loan-management-attachments-post-xml-json';
import { V3LoanManagementAttachmentsPost$Xml$Json$Params } from '../fn/loan-management/v-3-loan-management-attachments-post-xml-json';
import { v3LoanManagementAttachmentsPost$Xml$Plain } from '../fn/loan-management/v-3-loan-management-attachments-post-xml-plain';
import { V3LoanManagementAttachmentsPost$Xml$Plain$Params } from '../fn/loan-management/v-3-loan-management-attachments-post-xml-plain';
import { v3LoanManagementAttachmentsPost$Xml$Xml } from '../fn/loan-management/v-3-loan-management-attachments-post-xml-xml';
import { V3LoanManagementAttachmentsPost$Xml$Xml$Params } from '../fn/loan-management/v-3-loan-management-attachments-post-xml-xml';
import { v3LoanManagementAttachmentsUploadPost$Json } from '../fn/loan-management/v-3-loan-management-attachments-upload-post-json';
import { V3LoanManagementAttachmentsUploadPost$Json$Params } from '../fn/loan-management/v-3-loan-management-attachments-upload-post-json';
import { v3LoanManagementAttachmentsUploadPost$Plain } from '../fn/loan-management/v-3-loan-management-attachments-upload-post-plain';
import { V3LoanManagementAttachmentsUploadPost$Plain$Params } from '../fn/loan-management/v-3-loan-management-attachments-upload-post-plain';
import { v3LoanManagementAttachmentsUploadPost$Xml } from '../fn/loan-management/v-3-loan-management-attachments-upload-post-xml';
import { V3LoanManagementAttachmentsUploadPost$Xml$Params } from '../fn/loan-management/v-3-loan-management-attachments-upload-post-xml';
import { v3LoanManagementClientsGet$Json } from '../fn/loan-management/v-3-loan-management-clients-get-json';
import { V3LoanManagementClientsGet$Json$Params } from '../fn/loan-management/v-3-loan-management-clients-get-json';
import { v3LoanManagementClientsGet$Plain } from '../fn/loan-management/v-3-loan-management-clients-get-plain';
import { V3LoanManagementClientsGet$Plain$Params } from '../fn/loan-management/v-3-loan-management-clients-get-plain';
import { v3LoanManagementClientsGet$Xml } from '../fn/loan-management/v-3-loan-management-clients-get-xml';
import { V3LoanManagementClientsGet$Xml$Params } from '../fn/loan-management/v-3-loan-management-clients-get-xml';
import { v3LoanManagementClientsPagedGet$Json } from '../fn/loan-management/v-3-loan-management-clients-paged-get-json';
import { V3LoanManagementClientsPagedGet$Json$Params } from '../fn/loan-management/v-3-loan-management-clients-paged-get-json';
import { v3LoanManagementClientsPagedGet$Plain } from '../fn/loan-management/v-3-loan-management-clients-paged-get-plain';
import { V3LoanManagementClientsPagedGet$Plain$Params } from '../fn/loan-management/v-3-loan-management-clients-paged-get-plain';
import { v3LoanManagementClientsPagedGet$Xml } from '../fn/loan-management/v-3-loan-management-clients-paged-get-xml';
import { V3LoanManagementClientsPagedGet$Xml$Params } from '../fn/loan-management/v-3-loan-management-clients-paged-get-xml';
import { v3LoanManagementClientsSearchPost$Json$Json } from '../fn/loan-management/v-3-loan-management-clients-search-post-json-json';
import { V3LoanManagementClientsSearchPost$Json$Json$Params } from '../fn/loan-management/v-3-loan-management-clients-search-post-json-json';
import { v3LoanManagementClientsSearchPost$Json$Plain } from '../fn/loan-management/v-3-loan-management-clients-search-post-json-plain';
import { V3LoanManagementClientsSearchPost$Json$Plain$Params } from '../fn/loan-management/v-3-loan-management-clients-search-post-json-plain';
import { v3LoanManagementClientsSearchPost$Json$Xml } from '../fn/loan-management/v-3-loan-management-clients-search-post-json-xml';
import { V3LoanManagementClientsSearchPost$Json$Xml$Params } from '../fn/loan-management/v-3-loan-management-clients-search-post-json-xml';
import { v3LoanManagementClientsSearchPost$Xml$Json } from '../fn/loan-management/v-3-loan-management-clients-search-post-xml-json';
import { V3LoanManagementClientsSearchPost$Xml$Json$Params } from '../fn/loan-management/v-3-loan-management-clients-search-post-xml-json';
import { v3LoanManagementClientsSearchPost$Xml$Plain } from '../fn/loan-management/v-3-loan-management-clients-search-post-xml-plain';
import { V3LoanManagementClientsSearchPost$Xml$Plain$Params } from '../fn/loan-management/v-3-loan-management-clients-search-post-xml-plain';
import { v3LoanManagementClientsSearchPost$Xml$Xml } from '../fn/loan-management/v-3-loan-management-clients-search-post-xml-xml';
import { V3LoanManagementClientsSearchPost$Xml$Xml$Params } from '../fn/loan-management/v-3-loan-management-clients-search-post-xml-xml';
import { v3LoanManagementExternalPartiesExternalPartyGet$Json } from '../fn/loan-management/v-3-loan-management-external-parties-external-party-get-json';
import { V3LoanManagementExternalPartiesExternalPartyGet$Json$Params } from '../fn/loan-management/v-3-loan-management-external-parties-external-party-get-json';
import { v3LoanManagementExternalPartiesExternalPartyGet$Plain } from '../fn/loan-management/v-3-loan-management-external-parties-external-party-get-plain';
import { V3LoanManagementExternalPartiesExternalPartyGet$Plain$Params } from '../fn/loan-management/v-3-loan-management-external-parties-external-party-get-plain';
import { v3LoanManagementExternalPartiesExternalPartyGet$Xml } from '../fn/loan-management/v-3-loan-management-external-parties-external-party-get-xml';
import { V3LoanManagementExternalPartiesExternalPartyGet$Xml$Params } from '../fn/loan-management/v-3-loan-management-external-parties-external-party-get-xml';
import { v3LoanManagementLookupsMbiRateChartsGet$Json } from '../fn/loan-management/v-3-loan-management-lookups-mbi-rate-charts-get-json';
import { V3LoanManagementLookupsMbiRateChartsGet$Json$Params } from '../fn/loan-management/v-3-loan-management-lookups-mbi-rate-charts-get-json';
import { v3LoanManagementLookupsMbiRateChartsGet$Plain } from '../fn/loan-management/v-3-loan-management-lookups-mbi-rate-charts-get-plain';
import { V3LoanManagementLookupsMbiRateChartsGet$Plain$Params } from '../fn/loan-management/v-3-loan-management-lookups-mbi-rate-charts-get-plain';
import { v3LoanManagementLookupsMbiRateChartsGet$Xml } from '../fn/loan-management/v-3-loan-management-lookups-mbi-rate-charts-get-xml';
import { V3LoanManagementLookupsMbiRateChartsGet$Xml$Params } from '../fn/loan-management/v-3-loan-management-lookups-mbi-rate-charts-get-xml';
import { v3LoanManagementPingGet } from '../fn/loan-management/v-3-loan-management-ping-get';
import { V3LoanManagementPingGet$Params } from '../fn/loan-management/v-3-loan-management-ping-get';
import { v3LoanManagementQuotesPost$Json$Json } from '../fn/loan-management/v-3-loan-management-quotes-post-json-json';
import { V3LoanManagementQuotesPost$Json$Json$Params } from '../fn/loan-management/v-3-loan-management-quotes-post-json-json';
import { v3LoanManagementQuotesPost$Json$Plain } from '../fn/loan-management/v-3-loan-management-quotes-post-json-plain';
import { V3LoanManagementQuotesPost$Json$Plain$Params } from '../fn/loan-management/v-3-loan-management-quotes-post-json-plain';
import { v3LoanManagementQuotesPost$Json$Xml } from '../fn/loan-management/v-3-loan-management-quotes-post-json-xml';
import { V3LoanManagementQuotesPost$Json$Xml$Params } from '../fn/loan-management/v-3-loan-management-quotes-post-json-xml';
import { v3LoanManagementQuotesPost$Xml$Json } from '../fn/loan-management/v-3-loan-management-quotes-post-xml-json';
import { V3LoanManagementQuotesPost$Xml$Json$Params } from '../fn/loan-management/v-3-loan-management-quotes-post-xml-json';
import { v3LoanManagementQuotesPost$Xml$Plain } from '../fn/loan-management/v-3-loan-management-quotes-post-xml-plain';
import { V3LoanManagementQuotesPost$Xml$Plain$Params } from '../fn/loan-management/v-3-loan-management-quotes-post-xml-plain';
import { v3LoanManagementQuotesPost$Xml$Xml } from '../fn/loan-management/v-3-loan-management-quotes-post-xml-xml';
import { V3LoanManagementQuotesPost$Xml$Xml$Params } from '../fn/loan-management/v-3-loan-management-quotes-post-xml-xml';
import { v3LoanManagementSecurityItemsGet$Json } from '../fn/loan-management/v-3-loan-management-security-items-get-json';
import { V3LoanManagementSecurityItemsGet$Json$Params } from '../fn/loan-management/v-3-loan-management-security-items-get-json';
import { v3LoanManagementSecurityItemsGet$Plain } from '../fn/loan-management/v-3-loan-management-security-items-get-plain';
import { V3LoanManagementSecurityItemsGet$Plain$Params } from '../fn/loan-management/v-3-loan-management-security-items-get-plain';
import { v3LoanManagementSecurityItemsGet$Xml } from '../fn/loan-management/v-3-loan-management-security-items-get-xml';
import { V3LoanManagementSecurityItemsGet$Xml$Params } from '../fn/loan-management/v-3-loan-management-security-items-get-xml';
import { v3LoanManagementValidateBankAccountPost$Json$Json } from '../fn/loan-management/v-3-loan-management-validate-bank-account-post-json-json';
import { V3LoanManagementValidateBankAccountPost$Json$Json$Params } from '../fn/loan-management/v-3-loan-management-validate-bank-account-post-json-json';
import { v3LoanManagementValidateBankAccountPost$Json$Plain } from '../fn/loan-management/v-3-loan-management-validate-bank-account-post-json-plain';
import { V3LoanManagementValidateBankAccountPost$Json$Plain$Params } from '../fn/loan-management/v-3-loan-management-validate-bank-account-post-json-plain';
import { v3LoanManagementValidateBankAccountPost$Json$Xml } from '../fn/loan-management/v-3-loan-management-validate-bank-account-post-json-xml';
import { V3LoanManagementValidateBankAccountPost$Json$Xml$Params } from '../fn/loan-management/v-3-loan-management-validate-bank-account-post-json-xml';
import { v3LoanManagementValidateBankAccountPost$Xml$Json } from '../fn/loan-management/v-3-loan-management-validate-bank-account-post-xml-json';
import { V3LoanManagementValidateBankAccountPost$Xml$Json$Params } from '../fn/loan-management/v-3-loan-management-validate-bank-account-post-xml-json';
import { v3LoanManagementValidateBankAccountPost$Xml$Plain } from '../fn/loan-management/v-3-loan-management-validate-bank-account-post-xml-plain';
import { V3LoanManagementValidateBankAccountPost$Xml$Plain$Params } from '../fn/loan-management/v-3-loan-management-validate-bank-account-post-xml-plain';
import { v3LoanManagementValidateBankAccountPost$Xml$Xml } from '../fn/loan-management/v-3-loan-management-validate-bank-account-post-xml-xml';
import { V3LoanManagementValidateBankAccountPost$Xml$Xml$Params } from '../fn/loan-management/v-3-loan-management-validate-bank-account-post-xml-xml';

@Injectable({ providedIn: 'root' })
export class LoanManagementService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v3LoanManagementPingGet()` */
  static readonly V3LoanManagementPingGetPath = '/v3/loan-management/ping';

  /**
   * Authenticated Ping - returns 1 if authenticated and with correct role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementPingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementPingGet$Response(params?: V3LoanManagementPingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return v3LoanManagementPingGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with correct role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementPingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementPingGet(params?: V3LoanManagementPingGet$Params, context?: HttpContext): Observable<void> {
    return this.v3LoanManagementPingGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `v3LoanManagementQuotesPost()` */
  static readonly V3LoanManagementQuotesPostPath = '/v3/loan-management/quotes';

  /**
   * Generate account quote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementQuotesPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementQuotesPost$Json$Plain$Response(params?: V3LoanManagementQuotesPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>> {
    return v3LoanManagementQuotesPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Generate account quote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementQuotesPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementQuotesPost$Json$Plain(params?: V3LoanManagementQuotesPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAccountQuoteResponse> {
    return this.v3LoanManagementQuotesPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>): ModelsV3LoanManagementAccountQuoteResponse => r.body)
    );
  }

  /**
   * Generate account quote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementQuotesPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementQuotesPost$Json$Json$Response(params?: V3LoanManagementQuotesPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>> {
    return v3LoanManagementQuotesPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Generate account quote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementQuotesPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementQuotesPost$Json$Json(params?: V3LoanManagementQuotesPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAccountQuoteResponse> {
    return this.v3LoanManagementQuotesPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>): ModelsV3LoanManagementAccountQuoteResponse => r.body)
    );
  }

  /**
   * Generate account quote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementQuotesPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementQuotesPost$Json$Xml$Response(params?: V3LoanManagementQuotesPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>> {
    return v3LoanManagementQuotesPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Generate account quote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementQuotesPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementQuotesPost$Json$Xml(params?: V3LoanManagementQuotesPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAccountQuoteResponse> {
    return this.v3LoanManagementQuotesPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>): ModelsV3LoanManagementAccountQuoteResponse => r.body)
    );
  }

  /**
   * Generate account quote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementQuotesPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementQuotesPost$Xml$Plain$Response(params?: V3LoanManagementQuotesPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>> {
    return v3LoanManagementQuotesPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Generate account quote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementQuotesPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementQuotesPost$Xml$Plain(params?: V3LoanManagementQuotesPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAccountQuoteResponse> {
    return this.v3LoanManagementQuotesPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>): ModelsV3LoanManagementAccountQuoteResponse => r.body)
    );
  }

  /**
   * Generate account quote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementQuotesPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementQuotesPost$Xml$Json$Response(params?: V3LoanManagementQuotesPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>> {
    return v3LoanManagementQuotesPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Generate account quote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementQuotesPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementQuotesPost$Xml$Json(params?: V3LoanManagementQuotesPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAccountQuoteResponse> {
    return this.v3LoanManagementQuotesPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>): ModelsV3LoanManagementAccountQuoteResponse => r.body)
    );
  }

  /**
   * Generate account quote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementQuotesPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementQuotesPost$Xml$Xml$Response(params?: V3LoanManagementQuotesPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>> {
    return v3LoanManagementQuotesPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Generate account quote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementQuotesPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementQuotesPost$Xml$Xml(params?: V3LoanManagementQuotesPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAccountQuoteResponse> {
    return this.v3LoanManagementQuotesPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>): ModelsV3LoanManagementAccountQuoteResponse => r.body)
    );
  }

  /** Path part for operation `v3LoanManagementAccountsPost()` */
  static readonly V3LoanManagementAccountsPostPath = '/v3/loan-management/accounts';

  /**
   * Add account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAccountsPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementAccountsPost$Json$Plain$Response(params?: V3LoanManagementAccountsPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAccountRequest>> {
    return v3LoanManagementAccountsPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Add account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAccountsPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementAccountsPost$Json$Plain(params?: V3LoanManagementAccountsPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAccountRequest> {
    return this.v3LoanManagementAccountsPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAccountRequest>): ModelsV3LoanManagementAddAccountRequest => r.body)
    );
  }

  /**
   * Add account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAccountsPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementAccountsPost$Json$Json$Response(params?: V3LoanManagementAccountsPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAccountRequest>> {
    return v3LoanManagementAccountsPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Add account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAccountsPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementAccountsPost$Json$Json(params?: V3LoanManagementAccountsPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAccountRequest> {
    return this.v3LoanManagementAccountsPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAccountRequest>): ModelsV3LoanManagementAddAccountRequest => r.body)
    );
  }

  /**
   * Add account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAccountsPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementAccountsPost$Json$Xml$Response(params?: V3LoanManagementAccountsPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAccountRequest>> {
    return v3LoanManagementAccountsPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Add account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAccountsPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementAccountsPost$Json$Xml(params?: V3LoanManagementAccountsPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAccountRequest> {
    return this.v3LoanManagementAccountsPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAccountRequest>): ModelsV3LoanManagementAddAccountRequest => r.body)
    );
  }

  /**
   * Add account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAccountsPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementAccountsPost$Xml$Plain$Response(params?: V3LoanManagementAccountsPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAccountRequest>> {
    return v3LoanManagementAccountsPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Add account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAccountsPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementAccountsPost$Xml$Plain(params?: V3LoanManagementAccountsPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAccountRequest> {
    return this.v3LoanManagementAccountsPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAccountRequest>): ModelsV3LoanManagementAddAccountRequest => r.body)
    );
  }

  /**
   * Add account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAccountsPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementAccountsPost$Xml$Json$Response(params?: V3LoanManagementAccountsPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAccountRequest>> {
    return v3LoanManagementAccountsPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Add account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAccountsPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementAccountsPost$Xml$Json(params?: V3LoanManagementAccountsPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAccountRequest> {
    return this.v3LoanManagementAccountsPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAccountRequest>): ModelsV3LoanManagementAddAccountRequest => r.body)
    );
  }

  /**
   * Add account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAccountsPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementAccountsPost$Xml$Xml$Response(params?: V3LoanManagementAccountsPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAccountRequest>> {
    return v3LoanManagementAccountsPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Add account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAccountsPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementAccountsPost$Xml$Xml(params?: V3LoanManagementAccountsPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAccountRequest> {
    return this.v3LoanManagementAccountsPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAccountRequest>): ModelsV3LoanManagementAddAccountRequest => r.body)
    );
  }

  /** Path part for operation `v3LoanManagementClientsGet()` */
  static readonly V3LoanManagementClientsGetPath = '/v3/loan-management/clients';

  /**
   * Search for existing clients.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementClientsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  v3LoanManagementClientsGet$Plain$Response(params?: V3LoanManagementClientsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListBaseResponse>> {
    return v3LoanManagementClientsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for existing clients.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementClientsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  v3LoanManagementClientsGet$Plain(params?: V3LoanManagementClientsGet$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExistingClientResponseListBaseResponse> {
    return this.v3LoanManagementClientsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListBaseResponse>): ModelsV3LoanManagementExistingClientResponseListBaseResponse => r.body)
    );
  }

  /**
   * Search for existing clients.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementClientsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  v3LoanManagementClientsGet$Json$Response(params?: V3LoanManagementClientsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListBaseResponse>> {
    return v3LoanManagementClientsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for existing clients.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementClientsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  v3LoanManagementClientsGet$Json(params?: V3LoanManagementClientsGet$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExistingClientResponseListBaseResponse> {
    return this.v3LoanManagementClientsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListBaseResponse>): ModelsV3LoanManagementExistingClientResponseListBaseResponse => r.body)
    );
  }

  /**
   * Search for existing clients.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementClientsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  v3LoanManagementClientsGet$Xml$Response(params?: V3LoanManagementClientsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListBaseResponse>> {
    return v3LoanManagementClientsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for existing clients.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementClientsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  v3LoanManagementClientsGet$Xml(params?: V3LoanManagementClientsGet$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExistingClientResponseListBaseResponse> {
    return this.v3LoanManagementClientsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListBaseResponse>): ModelsV3LoanManagementExistingClientResponseListBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3LoanManagementClientsPagedGet()` */
  static readonly V3LoanManagementClientsPagedGetPath = '/v3/loan-management/clients-paged';

  /**
   * Search for existing clients.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementClientsPagedGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementClientsPagedGet$Plain$Response(params?: V3LoanManagementClientsPagedGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>> {
    return v3LoanManagementClientsPagedGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for existing clients.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementClientsPagedGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementClientsPagedGet$Plain(params?: V3LoanManagementClientsPagedGet$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse> {
    return this.v3LoanManagementClientsPagedGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>): ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse => r.body)
    );
  }

  /**
   * Search for existing clients.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementClientsPagedGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementClientsPagedGet$Json$Response(params?: V3LoanManagementClientsPagedGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>> {
    return v3LoanManagementClientsPagedGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for existing clients.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementClientsPagedGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementClientsPagedGet$Json(params?: V3LoanManagementClientsPagedGet$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse> {
    return this.v3LoanManagementClientsPagedGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>): ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse => r.body)
    );
  }

  /**
   * Search for existing clients.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementClientsPagedGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementClientsPagedGet$Xml$Response(params?: V3LoanManagementClientsPagedGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>> {
    return v3LoanManagementClientsPagedGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for existing clients.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementClientsPagedGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementClientsPagedGet$Xml(params?: V3LoanManagementClientsPagedGet$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse> {
    return this.v3LoanManagementClientsPagedGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>): ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3LoanManagementClientsSearchPost()` */
  static readonly V3LoanManagementClientsSearchPostPath = '/v3/loan-management/clients-search';

  /**
   * Search for existing clients (POST version).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementClientsSearchPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementClientsSearchPost$Json$Plain$Response(params?: V3LoanManagementClientsSearchPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>> {
    return v3LoanManagementClientsSearchPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for existing clients (POST version).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementClientsSearchPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementClientsSearchPost$Json$Plain(params?: V3LoanManagementClientsSearchPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse> {
    return this.v3LoanManagementClientsSearchPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>): ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse => r.body)
    );
  }

  /**
   * Search for existing clients (POST version).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementClientsSearchPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementClientsSearchPost$Json$Json$Response(params?: V3LoanManagementClientsSearchPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>> {
    return v3LoanManagementClientsSearchPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for existing clients (POST version).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementClientsSearchPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementClientsSearchPost$Json$Json(params?: V3LoanManagementClientsSearchPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse> {
    return this.v3LoanManagementClientsSearchPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>): ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse => r.body)
    );
  }

  /**
   * Search for existing clients (POST version).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementClientsSearchPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementClientsSearchPost$Json$Xml$Response(params?: V3LoanManagementClientsSearchPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>> {
    return v3LoanManagementClientsSearchPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for existing clients (POST version).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementClientsSearchPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementClientsSearchPost$Json$Xml(params?: V3LoanManagementClientsSearchPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse> {
    return this.v3LoanManagementClientsSearchPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>): ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse => r.body)
    );
  }

  /**
   * Search for existing clients (POST version).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementClientsSearchPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementClientsSearchPost$Xml$Plain$Response(params?: V3LoanManagementClientsSearchPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>> {
    return v3LoanManagementClientsSearchPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for existing clients (POST version).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementClientsSearchPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementClientsSearchPost$Xml$Plain(params?: V3LoanManagementClientsSearchPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse> {
    return this.v3LoanManagementClientsSearchPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>): ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse => r.body)
    );
  }

  /**
   * Search for existing clients (POST version).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementClientsSearchPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementClientsSearchPost$Xml$Json$Response(params?: V3LoanManagementClientsSearchPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>> {
    return v3LoanManagementClientsSearchPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for existing clients (POST version).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementClientsSearchPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementClientsSearchPost$Xml$Json(params?: V3LoanManagementClientsSearchPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse> {
    return this.v3LoanManagementClientsSearchPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>): ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse => r.body)
    );
  }

  /**
   * Search for existing clients (POST version).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementClientsSearchPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementClientsSearchPost$Xml$Xml$Response(params?: V3LoanManagementClientsSearchPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>> {
    return v3LoanManagementClientsSearchPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for existing clients (POST version).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementClientsSearchPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementClientsSearchPost$Xml$Xml(params?: V3LoanManagementClientsSearchPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse> {
    return this.v3LoanManagementClientsSearchPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>): ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3LoanManagementLookupsMbiRateChartsGet()` */
  static readonly V3LoanManagementLookupsMbiRateChartsGetPath = '/v3/loan-management/lookups/mbi-rate-charts';

  /**
   * Get MBI Rate Charts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementLookupsMbiRateChartsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  v3LoanManagementLookupsMbiRateChartsGet$Plain$Response(params?: V3LoanManagementLookupsMbiRateChartsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ModelsV3LoanManagementMbiRateChartResponse>>> {
    return v3LoanManagementLookupsMbiRateChartsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get MBI Rate Charts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementLookupsMbiRateChartsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  v3LoanManagementLookupsMbiRateChartsGet$Plain(params?: V3LoanManagementLookupsMbiRateChartsGet$Plain$Params, context?: HttpContext): Observable<Array<ModelsV3LoanManagementMbiRateChartResponse>> {
    return this.v3LoanManagementLookupsMbiRateChartsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ModelsV3LoanManagementMbiRateChartResponse>>): Array<ModelsV3LoanManagementMbiRateChartResponse> => r.body)
    );
  }

  /**
   * Get MBI Rate Charts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementLookupsMbiRateChartsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  v3LoanManagementLookupsMbiRateChartsGet$Json$Response(params?: V3LoanManagementLookupsMbiRateChartsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ModelsV3LoanManagementMbiRateChartResponse>>> {
    return v3LoanManagementLookupsMbiRateChartsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get MBI Rate Charts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementLookupsMbiRateChartsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  v3LoanManagementLookupsMbiRateChartsGet$Json(params?: V3LoanManagementLookupsMbiRateChartsGet$Json$Params, context?: HttpContext): Observable<Array<ModelsV3LoanManagementMbiRateChartResponse>> {
    return this.v3LoanManagementLookupsMbiRateChartsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ModelsV3LoanManagementMbiRateChartResponse>>): Array<ModelsV3LoanManagementMbiRateChartResponse> => r.body)
    );
  }

  /**
   * Get MBI Rate Charts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementLookupsMbiRateChartsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  v3LoanManagementLookupsMbiRateChartsGet$Xml$Response(params?: V3LoanManagementLookupsMbiRateChartsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ModelsV3LoanManagementMbiRateChartResponse>>> {
    return v3LoanManagementLookupsMbiRateChartsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Get MBI Rate Charts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementLookupsMbiRateChartsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  v3LoanManagementLookupsMbiRateChartsGet$Xml(params?: V3LoanManagementLookupsMbiRateChartsGet$Xml$Params, context?: HttpContext): Observable<Array<ModelsV3LoanManagementMbiRateChartResponse>> {
    return this.v3LoanManagementLookupsMbiRateChartsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ModelsV3LoanManagementMbiRateChartResponse>>): Array<ModelsV3LoanManagementMbiRateChartResponse> => r.body)
    );
  }

  /** Path part for operation `v3LoanManagementExternalPartiesExternalPartyGet()` */
  static readonly V3LoanManagementExternalPartiesExternalPartyGetPath = '/v3/loan-management/external-parties/external-party';

  /**
   * Get external party.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementExternalPartiesExternalPartyGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementExternalPartiesExternalPartyGet$Plain$Response(params?: V3LoanManagementExternalPartiesExternalPartyGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExternalPartyResponse>> {
    return v3LoanManagementExternalPartiesExternalPartyGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get external party.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementExternalPartiesExternalPartyGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementExternalPartiesExternalPartyGet$Plain(params?: V3LoanManagementExternalPartiesExternalPartyGet$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExternalPartyResponse> {
    return this.v3LoanManagementExternalPartiesExternalPartyGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExternalPartyResponse>): ModelsV3LoanManagementExternalPartyResponse => r.body)
    );
  }

  /**
   * Get external party.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementExternalPartiesExternalPartyGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementExternalPartiesExternalPartyGet$Json$Response(params?: V3LoanManagementExternalPartiesExternalPartyGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExternalPartyResponse>> {
    return v3LoanManagementExternalPartiesExternalPartyGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get external party.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementExternalPartiesExternalPartyGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementExternalPartiesExternalPartyGet$Json(params?: V3LoanManagementExternalPartiesExternalPartyGet$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExternalPartyResponse> {
    return this.v3LoanManagementExternalPartiesExternalPartyGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExternalPartyResponse>): ModelsV3LoanManagementExternalPartyResponse => r.body)
    );
  }

  /**
   * Get external party.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementExternalPartiesExternalPartyGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementExternalPartiesExternalPartyGet$Xml$Response(params?: V3LoanManagementExternalPartiesExternalPartyGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExternalPartyResponse>> {
    return v3LoanManagementExternalPartiesExternalPartyGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Get external party.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementExternalPartiesExternalPartyGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementExternalPartiesExternalPartyGet$Xml(params?: V3LoanManagementExternalPartiesExternalPartyGet$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementExternalPartyResponse> {
    return this.v3LoanManagementExternalPartiesExternalPartyGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementExternalPartyResponse>): ModelsV3LoanManagementExternalPartyResponse => r.body)
    );
  }

  /** Path part for operation `v3LoanManagementSecurityItemsGet()` */
  static readonly V3LoanManagementSecurityItemsGetPath = '/v3/loan-management/security-items';

  /**
   * Get security items.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementSecurityItemsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementSecurityItemsGet$Plain$Response(params?: V3LoanManagementSecurityItemsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ModelsV3LoanManagementSecurityItemResponse>>> {
    return v3LoanManagementSecurityItemsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get security items.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementSecurityItemsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementSecurityItemsGet$Plain(params?: V3LoanManagementSecurityItemsGet$Plain$Params, context?: HttpContext): Observable<Array<ModelsV3LoanManagementSecurityItemResponse>> {
    return this.v3LoanManagementSecurityItemsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ModelsV3LoanManagementSecurityItemResponse>>): Array<ModelsV3LoanManagementSecurityItemResponse> => r.body)
    );
  }

  /**
   * Get security items.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementSecurityItemsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementSecurityItemsGet$Json$Response(params?: V3LoanManagementSecurityItemsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ModelsV3LoanManagementSecurityItemResponse>>> {
    return v3LoanManagementSecurityItemsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get security items.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementSecurityItemsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementSecurityItemsGet$Json(params?: V3LoanManagementSecurityItemsGet$Json$Params, context?: HttpContext): Observable<Array<ModelsV3LoanManagementSecurityItemResponse>> {
    return this.v3LoanManagementSecurityItemsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ModelsV3LoanManagementSecurityItemResponse>>): Array<ModelsV3LoanManagementSecurityItemResponse> => r.body)
    );
  }

  /**
   * Get security items.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementSecurityItemsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementSecurityItemsGet$Xml$Response(params?: V3LoanManagementSecurityItemsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ModelsV3LoanManagementSecurityItemResponse>>> {
    return v3LoanManagementSecurityItemsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Get security items.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementSecurityItemsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementSecurityItemsGet$Xml(params?: V3LoanManagementSecurityItemsGet$Xml$Params, context?: HttpContext): Observable<Array<ModelsV3LoanManagementSecurityItemResponse>> {
    return this.v3LoanManagementSecurityItemsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ModelsV3LoanManagementSecurityItemResponse>>): Array<ModelsV3LoanManagementSecurityItemResponse> => r.body)
    );
  }

  /** Path part for operation `v3LoanManagementAccountTypesGet()` */
  static readonly V3LoanManagementAccountTypesGetPath = '/v3/loan-management/account-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAccountTypesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementAccountTypesGet$Plain$Response(params?: V3LoanManagementAccountTypesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse>> {
    return v3LoanManagementAccountTypesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAccountTypesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementAccountTypesGet$Plain(params?: V3LoanManagementAccountTypesGet$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse> {
    return this.v3LoanManagementAccountTypesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse>): ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAccountTypesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementAccountTypesGet$Json$Response(params?: V3LoanManagementAccountTypesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse>> {
    return v3LoanManagementAccountTypesGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAccountTypesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementAccountTypesGet$Json(params?: V3LoanManagementAccountTypesGet$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse> {
    return this.v3LoanManagementAccountTypesGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse>): ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAccountTypesGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementAccountTypesGet$Xml$Response(params?: V3LoanManagementAccountTypesGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse>> {
    return v3LoanManagementAccountTypesGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAccountTypesGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3LoanManagementAccountTypesGet$Xml(params?: V3LoanManagementAccountTypesGet$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse> {
    return this.v3LoanManagementAccountTypesGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse>): ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3LoanManagementAttachmentsPost()` */
  static readonly V3LoanManagementAttachmentsPostPath = '/v3/loan-management/attachments';

  /**
   * Add attachment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAttachmentsPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementAttachmentsPost$Json$Plain$Response(params?: V3LoanManagementAttachmentsPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>> {
    return v3LoanManagementAttachmentsPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Add attachment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAttachmentsPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementAttachmentsPost$Json$Plain(params?: V3LoanManagementAttachmentsPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse> {
    return this.v3LoanManagementAttachmentsPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>): ModelsV3LoanManagementAddAttachmentsResponseBaseResponse => r.body)
    );
  }

  /**
   * Add attachment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAttachmentsPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementAttachmentsPost$Json$Json$Response(params?: V3LoanManagementAttachmentsPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>> {
    return v3LoanManagementAttachmentsPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Add attachment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAttachmentsPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementAttachmentsPost$Json$Json(params?: V3LoanManagementAttachmentsPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse> {
    return this.v3LoanManagementAttachmentsPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>): ModelsV3LoanManagementAddAttachmentsResponseBaseResponse => r.body)
    );
  }

  /**
   * Add attachment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAttachmentsPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementAttachmentsPost$Json$Xml$Response(params?: V3LoanManagementAttachmentsPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>> {
    return v3LoanManagementAttachmentsPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Add attachment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAttachmentsPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementAttachmentsPost$Json$Xml(params?: V3LoanManagementAttachmentsPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse> {
    return this.v3LoanManagementAttachmentsPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>): ModelsV3LoanManagementAddAttachmentsResponseBaseResponse => r.body)
    );
  }

  /**
   * Add attachment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAttachmentsPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementAttachmentsPost$Xml$Plain$Response(params?: V3LoanManagementAttachmentsPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>> {
    return v3LoanManagementAttachmentsPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Add attachment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAttachmentsPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementAttachmentsPost$Xml$Plain(params?: V3LoanManagementAttachmentsPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse> {
    return this.v3LoanManagementAttachmentsPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>): ModelsV3LoanManagementAddAttachmentsResponseBaseResponse => r.body)
    );
  }

  /**
   * Add attachment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAttachmentsPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementAttachmentsPost$Xml$Json$Response(params?: V3LoanManagementAttachmentsPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>> {
    return v3LoanManagementAttachmentsPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Add attachment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAttachmentsPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementAttachmentsPost$Xml$Json(params?: V3LoanManagementAttachmentsPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse> {
    return this.v3LoanManagementAttachmentsPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>): ModelsV3LoanManagementAddAttachmentsResponseBaseResponse => r.body)
    );
  }

  /**
   * Add attachment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAttachmentsPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementAttachmentsPost$Xml$Xml$Response(params?: V3LoanManagementAttachmentsPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>> {
    return v3LoanManagementAttachmentsPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Add attachment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAttachmentsPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementAttachmentsPost$Xml$Xml(params?: V3LoanManagementAttachmentsPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse> {
    return this.v3LoanManagementAttachmentsPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>): ModelsV3LoanManagementAddAttachmentsResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3LoanManagementAttachmentsUploadPost()` */
  static readonly V3LoanManagementAttachmentsUploadPostPath = '/v3/loan-management/attachments/upload';

  /**
   * Upload a single attachment as multipart/form-data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAttachmentsUploadPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v3LoanManagementAttachmentsUploadPost$Plain$Response(params?: V3LoanManagementAttachmentsUploadPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>> {
    return v3LoanManagementAttachmentsUploadPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload a single attachment as multipart/form-data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAttachmentsUploadPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v3LoanManagementAttachmentsUploadPost$Plain(params?: V3LoanManagementAttachmentsUploadPost$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse> {
    return this.v3LoanManagementAttachmentsUploadPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>): ModelsV3LoanManagementAddAttachmentsResponseBaseResponse => r.body)
    );
  }

  /**
   * Upload a single attachment as multipart/form-data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAttachmentsUploadPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v3LoanManagementAttachmentsUploadPost$Json$Response(params?: V3LoanManagementAttachmentsUploadPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>> {
    return v3LoanManagementAttachmentsUploadPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload a single attachment as multipart/form-data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAttachmentsUploadPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v3LoanManagementAttachmentsUploadPost$Json(params?: V3LoanManagementAttachmentsUploadPost$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse> {
    return this.v3LoanManagementAttachmentsUploadPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>): ModelsV3LoanManagementAddAttachmentsResponseBaseResponse => r.body)
    );
  }

  /**
   * Upload a single attachment as multipart/form-data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementAttachmentsUploadPost$Xml()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v3LoanManagementAttachmentsUploadPost$Xml$Response(params?: V3LoanManagementAttachmentsUploadPost$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>> {
    return v3LoanManagementAttachmentsUploadPost$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload a single attachment as multipart/form-data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementAttachmentsUploadPost$Xml$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v3LoanManagementAttachmentsUploadPost$Xml(params?: V3LoanManagementAttachmentsUploadPost$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse> {
    return this.v3LoanManagementAttachmentsUploadPost$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>): ModelsV3LoanManagementAddAttachmentsResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3LoanManagementValidateBankAccountPost()` */
  static readonly V3LoanManagementValidateBankAccountPostPath = '/v3/loan-management/validate-bank-account';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementValidateBankAccountPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementValidateBankAccountPost$Json$Plain$Response(params?: V3LoanManagementValidateBankAccountPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse>> {
    return v3LoanManagementValidateBankAccountPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementValidateBankAccountPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementValidateBankAccountPost$Json$Plain(params?: V3LoanManagementValidateBankAccountPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse> {
    return this.v3LoanManagementValidateBankAccountPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse>): ModelsV3LoanManagementValidateBankAccountResponseBaseResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementValidateBankAccountPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementValidateBankAccountPost$Json$Json$Response(params?: V3LoanManagementValidateBankAccountPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse>> {
    return v3LoanManagementValidateBankAccountPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementValidateBankAccountPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementValidateBankAccountPost$Json$Json(params?: V3LoanManagementValidateBankAccountPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse> {
    return this.v3LoanManagementValidateBankAccountPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse>): ModelsV3LoanManagementValidateBankAccountResponseBaseResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementValidateBankAccountPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementValidateBankAccountPost$Json$Xml$Response(params?: V3LoanManagementValidateBankAccountPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse>> {
    return v3LoanManagementValidateBankAccountPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementValidateBankAccountPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3LoanManagementValidateBankAccountPost$Json$Xml(params?: V3LoanManagementValidateBankAccountPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse> {
    return this.v3LoanManagementValidateBankAccountPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse>): ModelsV3LoanManagementValidateBankAccountResponseBaseResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementValidateBankAccountPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementValidateBankAccountPost$Xml$Plain$Response(params?: V3LoanManagementValidateBankAccountPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse>> {
    return v3LoanManagementValidateBankAccountPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementValidateBankAccountPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementValidateBankAccountPost$Xml$Plain(params?: V3LoanManagementValidateBankAccountPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse> {
    return this.v3LoanManagementValidateBankAccountPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse>): ModelsV3LoanManagementValidateBankAccountResponseBaseResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementValidateBankAccountPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementValidateBankAccountPost$Xml$Json$Response(params?: V3LoanManagementValidateBankAccountPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse>> {
    return v3LoanManagementValidateBankAccountPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementValidateBankAccountPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementValidateBankAccountPost$Xml$Json(params?: V3LoanManagementValidateBankAccountPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse> {
    return this.v3LoanManagementValidateBankAccountPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse>): ModelsV3LoanManagementValidateBankAccountResponseBaseResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3LoanManagementValidateBankAccountPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementValidateBankAccountPost$Xml$Xml$Response(params?: V3LoanManagementValidateBankAccountPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse>> {
    return v3LoanManagementValidateBankAccountPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3LoanManagementValidateBankAccountPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3LoanManagementValidateBankAccountPost$Xml$Xml(params?: V3LoanManagementValidateBankAccountPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse> {
    return this.v3LoanManagementValidateBankAccountPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse>): ModelsV3LoanManagementValidateBankAccountResponseBaseResponse => r.body)
    );
  }

}
